class MiniCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cart = JSON.parse(
      this.querySelector('[type="application/json"]').textContent || "{}"
    );
    this.drawer = this.querySelector(".mini_drawer__wrapper");
    this.overlay = this.querySelector(".mini_drawer__overlay");
    this.cartIcon = this.querySelector(".header__icon--cart");
    this.closeButton = this.querySelector(".mini_drawer__close");
    this.cartItemsList = this.querySelector(".mini_drawer__items");
    this.cartItems = this.querySelectorAll(".mini_drawer__item_product");
    this.deleteItemButtons = null;

    this.cartIcon.addEventListener("click", this.open.bind(this));
    this.overlay.addEventListener("click", this.close.bind(this));
    this.closeButton.addEventListener("click", this.close.bind(this));

    this.init();
  }

  init() {
    this.renderContents(this.cart.items);
  }

  open() {
    this.drawer.classList.add("open");
    this.overlay.classList.add("open");

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  close() {
    this.drawer.classList.remove("open");
    this.overlay.classList.remove("open");
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  renderContents(items) {
    if (items.length > 0) {
      items
        .map((item) => {
          const liItem = document.createElement("li");
          liItem.classList.add("mini_drawer__item_product");

          const figureItem = document.createElement("figure");
          figureItem.classList.add("mini_drawer__item_image");

          const imgItem = document.createElement("img");
          imgItem.src = item.image;
          imgItem.alt = item.title;
          imgItem.width = "100";
          imgItem.height = "100";

          figureItem.appendChild(imgItem);

          const infoItem = document.createElement("div");
          infoItem.classList.add("mini_drawer__item_info");

          const titleItem = document.createElement("h5");
          titleItem.textContent = item.title;

          const priceItem = document.createElement("p");

          const priceValue = new Intl.NumberFormat("de-DE", {
            style: "decimal",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }).format(item.price / 100);

          priceItem.textContent = `$${priceValue}`;

          const deleteItem = document.createElement("span");
          deleteItem.classList.add("mini_drawer__item_delete");
          deleteItem.textContent = "+";
          deleteItem.dataset.id = item.id;

          infoItem.appendChild(titleItem);
          infoItem.appendChild(priceItem);
          infoItem.appendChild(deleteItem);

          liItem.appendChild(figureItem);
          liItem.appendChild(infoItem);

          this.cartItemsList.appendChild(liItem);

          this.querySelectorAll(".mini_drawer__item_delete").forEach((item) => {
            item.addEventListener("click", this.deleteItem.bind(this));
          });
        })
        .join("");
    } else {
      const liItem = document.createElement("li");
      liItem.classList.add("mini_drawer__item_empty");

      const text = document.createElement("p");
      text.textContent = "El carrito está vacio";

      liItem.appendChild(text);

      this.cartItemsList.appendChild(liItem);
    }
  }

  addToCartHandler() {
    this.refreshCart();
  }

  resetCartItems() {
    this.cartItemsList.innerHTML = '';
  }

  async getCartItems() {
    const items = await fetch("/cart.js");
    const response = await items.json();

    return response;
  }

  async deleteItem(e) {
    if (!e.currentTarget.dataset.id) return;

    let updates = {};

    updates[e.target.dataset.id] = 0;

    try {
      const response = await fetch(
        window.Shopify.routes.root + "cart/update.js",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        }
      );

      const result = await response.json();

      if (!result) return;

      await this.refreshCart(result, false);

      return result;
    } catch (error) {
      console.error("Error:", error);
    }
  }

  updateCountBubble(number = 0) {
    this.querySelector(
      ".cart-count-bubble > span.visually-visible"
    ).textContent = `${number}`;
    this.querySelector(
      ".cart-count-bubble > span.visually-hidden"
    ).textContent = `${number} items`;
  }

  updateSubtotal(subtotal = 0) {
    let price = subtotal / 100;
    price = price.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });

    this.querySelector(
      ".mini_drawer__total"
    ).textContent = `Subtotal: ${price}`;
  }

  updateButton(cartItems) {
    const button = this.querySelector(".mini_drawer__cta .button");

    console.log("cartItems", cartItems);

    if (cartItems.length > 0) {
      button.textContent = `Ver mi carrito (${cartItems.length})`;
    } else {
      button.textContent = button.dataset.empty;
    }
  }

  async refreshCart(cartData = null, open = false) {
    // console.log("REFRESH CART");
    this.resetCartItems();

    const cart = await this.getCartItems();

    console.log("🚀 ~ MiniCartDrawer ~ refreshCart ~ cart:", cart);

    this.renderContents(cart.items);

    this.updateCountBubble(cart.item_count);
    this.updateSubtotal(cart.total_price);
    this.updateButton(cart.items);

    if (!open) return;

    this.open();
  }
}

customElements.define("mini-cart-drawer", MiniCartDrawer);
